<template>
  <div class="notification-internship-widget">
    <div class="notification-container">
      <div class="header">
        <h1>Survey</h1>
        <h2 v-if="questionnaire" class="questionale_title">
          {{ questionnaire.title }}
        </h2>
        <p v-if="questionnaire" class="questionale_descr">
          {{ questionnaire.description }}
        </p>
      </div>
      <div class="body">
        <template v-for="(item, index) in questions">
          <div class="section-item" :class="item.section_type" v-if="item.section_type == 'question'" :key="index">
            <div class="question-header">
              <label>{{ item.ask }}</label>
            </div>
            <!-- Short Answer -->
            <div class="question-body" v-if="item.question_type == 'short_answer'">
              <input type="text" v-model="item.answer" class="short-answer-input" placeholder="Answer" />
            </div>
            <!-- Long Answer -->
            <div class="question-body" v-if="item.question_type == 'paragraph'">
              <textarea type="text" v-model="item.answer" class="long-answer-input" placeholder="Answer"></textarea>
            </div>

            <!-- Radio Answer -->
            <div class="question-body" v-if="item.question_type == 'multiple_choice'">
              <div class="radio-widget">
                <div class="radio-item" v-for="(choice, choice_index) in item.choice_options" :key="choice_index">
                  <input class="choice-input" type="radio" :id="'radion_id_' + choice_index" :name="'radion_' + index"
                    v-model="item.answer" :value="choice.value" />
                  <label :for="'radion_id_' + choice_index">{{
                    choice.name
                  }}</label>
                </div>
              </div>
            </div>

            <!-- Checkbox Answer -->
            <div class="question-body" v-if="item.question_type == 'checkboxes'">
              <div class="radio-widget">
                <div class="radio-item" v-for="(choice, choice_index) in item.choice_options" :key="choice_index">
                  <input class="choice-input" type="checkbox" :id="'radion_id_' + choice_index" v-model="choice.value" />
                  <label :for="'radion_id_' + choice_index">{{
                    choice.name
                  }}</label>
                </div>
              </div>
            </div>
            <!-- Checkbox Answer -->
            <div class="question-body" v-if="item.question_type == 'dropdown'">
              <div class="select-widget">
                <select class="select-input" v-model="item.answer">
                  <option value="" disabled>Select</option>
                  <option class="radio-item" v-for="(choice, choice_index) in item.choice_options" :key="choice_index"
                    :value="choice.value">
                    {{ choice.name }}
                  </option>
                </select>
              </div>
            </div>
            <!-- Upload Answer -->
            <div class="question-body" v-if="item.question_type == 'file_upload'">
              <div class="upload-widget">
                <upload :crop="false" :ration="8 / 4" @onFileSelected="uploadSurveyImage($event, item)" :max_size="5"
                  caption="Upload your file" remove_caption="Remove file" />
              </div>
            </div>

            <!-- Date Answer -->
            <div class="question-body" v-if="item.question_type == 'date'">
              <div class="date-widget">
                <datepicker :monday-first="true" placeholder="Select date" v-model="item.answer"
                  input-class="__date-field" wrapper-class="__date-field"></datepicker>
              </div>
            </div>

            <!-- Time picker -->
            <div class="question-body" v-if="item.question_type == 'time'">
              <div class="date-widget">
                <vue-timepicker input-class="time-input" placeholder="Select Time" v-model="item.answer"
                  format="hh:mm A"></vue-timepicker>
              </div>
            </div>
          </div>
          <!-- Title -->
          <div class="section-item" :class="item.section_type + '_widget'" v-if="item.section_type == 'title'"
            :key="index">
            <h2>{{ item.title }}</h2>
            <p v-if="item.description">{{ item.description }}</p>
          </div>
          <!-- Section -->
          <div class="section-item" :class="item.section_type" v-if="item.section_type == 'section'" :key="index">
            <h1>{{ item.title }}</h1>
            <p v-if="item.description">{{ item.description }}</p>
          </div>

          <!-- Image -->
          <div class="section-item" :class="item.section_type" v-if="item.section_type == 'image'" :key="index">
            <h1>{{ item.title }}</h1>
            <img width="100%" :src="$fullUrl('images/' + item.file_name)" alt="" />
          </div>
          <!-- Video -->
          <div class="section-item" :class="item.section_type" v-if="item.section_type == 'video'" :key="index">
            <h1>{{ item.title }}</h1>
            <video width="100%" :src="$fullUrl('images/' + item.file_name)" controls />
          </div>
        </template>
      </div>
      <div class="footer">
        <c-button class="btn-save" :loading="accept_loading" @click="submitQuestionnaireAnswer()">Submit</c-button>
        <c-button class="btn-cancel" :loading="reject_loading" @click="rejectNotification()">Cancel</c-button>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../main";
import upload from "@/components/Partials/Uploader.vue";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "notification-internship",
  components: {
    upload,
    Datepicker,
    VueTimepicker,
  },
  computed: {
    ...mapGetters([
      "getMeProfile",
      "getSearchResults",
      "getFeedsPosts",
      "getLoader",
    ]),
  },
  props: {},
  data: () => {
    return {
      accept_loading: false,
      reject_loading: false,
      form_data: {
        survey_id: null,
        user_id: null,
        answers: "",
        type: "feed",
      },
      questions: [],
      questionnaire: null,
    };
  },
  mounted() {
    let vm = this;
    if (vm.$getLoggedUser() && vm.$getLoggedUser().id) {
      vm.form_data.user_id = vm.$getLoggedUser().id;
      vm.form_data.survey_id = vm.$route.params.survey_id;
      vm.getQuestions(vm.form_data.survey_id);
    } else {
      vm.$logoutUserAndSaveCurrentPath();
    }
  },
  methods: {
    rejectNotification() {
      let vm = this;
      vm.$router.push({ path: "/feeds" });
    },
    submitQuestionnaireAnswer() {
      let vm = this;
      let file_to_upload = [];
      vm.questions.forEach((item) => {
        if (item.question_type == "file_upload") {
          if (item.file_obj) {
            file_to_upload.push(item);
          }
        }
        return item;
      });
      vm.accept_loading = true;
      if (file_to_upload.length > 0) {
        vm.uploadSurveyFile(file_to_upload);
      } else {
        vm.saveQuestionnaireAnswer();
      }
    },
    uploadSurveyFile(files) {
      let vm = this;
      let form_data = new FormData();
      files.forEach((item) => {
        form_data.append("files[]", item.file_obj, item.file_name);
      });
      vm.$store
        .dispatch("UPLOAD_MILTIPLE_FILE", form_data)
        .then((value) => {
          vm.submitQuestionnaireAnswer();
        })
        .catch((reason) => {
          vm.accept_loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    saveQuestionnaireAnswer() {
      let vm = this;
      vm.form_data.answers = JSON.stringify(vm.questions);
      vm.$store
        .dispatch("STUDENT_SUBMIT_ANSWERS", vm.form_data)
        .then((value) => {
          vm.accept_loading = false;

          eventBus.$emit("openDialogMessage", {
            title: "Thank you",
            message: "Your response has been sent.",
            action_label: "",
            action_path: "",
            action_close_label: "Close",
          });

          vm.$router.push({ path: "/feeds" });
        })
        .catch((error) => {
          vm.accept_loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: error.response.data.message,
            type: "warn",
            duration: 3000,
          });
        });
    },
    getQuestions(id) {
      let vm = this;
      vm.$store
        .dispatch("STUDENT_GET_QUESTIONS", { id: id, type: "survey" })
        .then((responce) => {
          vm.questionnaire = responce.data;
          let questions = JSON.parse(responce.data.question);
          vm.form_data.survey_id = responce.data.id;
          vm.questions = questions.map((item) => {
            eventBus.$set(item, "answer", "");
            if (item.question_type == "checkboxes") {
              item.choice_options.map((choice) => {
                eventBus.$set(choice, "value", false);
                return choice;
              });
            }
            if (item.question_type == "file_upload") {
              eventBus.$set(item, "file_obj", null);
            }
            return item;
          });
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    uploadSurveyImage(file, item) {
      if (file) {
        item.file_obj = file;
        item.file_name = Date.now() + file.name;
      } else {
        item.file_obj = null;
        item.file_name = "";
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.notification-internship-widget {
  background: #ededed;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 100px;
  overflow-y: scroll;
  height: 100vh;

  .notification-container {
    width: 700px;
    background: #fff;
    border-radius: 5px;
    padding: 20px;

    .header {
      padding: 10px;

      h1 {
        margin: 0px;
        font-size: 30px;
      }

      .questionale_title {
        font-size: 18px;
        font-weight: 600;
        color: rgb(35, 35, 35);
        margin-top: 10px;
      }

      .questionale_descr {
        font-size: 14px;
        font-weight: 400;
        color: rgb(64, 64, 64);
      }
    }

    .body {
      padding: 10px;

      .section-item {
        &.question {
          margin-bottom: 20px;

          .question-header {
            font-size: 15px;
          }

          .question-body {
            .short-answer-input {
              height: 40px;
              width: 100%;
              border: 1px solid #ddd;
              border-radius: 5px;
              padding: 0px 10px;
              outline: none;
            }

            .long-answer-input {
              height: 100px;
              width: 100%;
              border: 1px solid #ddd;
              border-radius: 5px;
              padding: 10px;
              outline: none;
            }

            .radio-widget {
              margin-top: 10px;

              .radio-item {
                display: flex;
                align-items: center;
                margin-bottom: 5px;

                .choice-input {
                  margin-right: 10px;
                }
              }
            }

            .select-widget {
              .select-input {
                height: 40px;
                width: 200px;
                border: 1px solid #ddd;
                border-radius: 5px;
                padding: 0px 10px;
                outline: none;
              }
            }

            .date-widget {
              .__date-field {
                height: 40px;
                width: 200px;
                border: 1px solid #ddd;
                border-radius: 5px;
                padding: 10px 10px;
                outline: none;
              }
            }
          }
        }

        &.title_widget {
          margin-bottom: 6px;

          h2 {
            font-size: 17px;
            color: #000;
          }

          p {
            font-size: 13px;
            color: rgb(153, 153, 153);
          }
        }

        &.section {
          border-bottom: 4px solid rgb(194, 192, 192);

          h2 {
            font-size: 20px;
            color: #000;
          }

          p {
            font-size: 15px;
            color: rgb(153, 153, 153);
            margin-bottom: 1px;
          }
        }
      }
    }

    .footer {
      padding: 10px;
      display: flex;
      align-items: center;

      .btn-save {
        width: 100px;
        height: 40px;
        background: #229ea5;
        border-radius: 6px;
        color: #fff;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn-cancel {
        width: 100px;
        height: 40px;
        background: #fff;
        border-radius: 6px;
        color: #229ea5;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>

<style lang="scss">
.time-input {
  height: 40px !important;
  width: 200px !important;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px 10px;
  outline: none;
}
</style>